import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Layout from './../Layout';
import Cookies from 'js-cookie';
import CryptoJS from 'crypto-js';
import axios from 'axios';

// --- IMPORTANT: Store this key securely, do NOT hardcode in production ---
// For a real app, use environment variables: process.env.REACT_APP_COOKIE_SECRET_KEY
const SECRET_COOKIE_KEY = "mySuperSecretCookieKey123!@#"; // Change this to a strong, random key

// Helper functions for encryption/decryption
const encrypt = (text) => {
  return CryptoJS.AES.encrypt(text, SECRET_COOKIE_KEY).toString();
};

const decrypt = (ciphertext) => {
  try {
    const bytes = CryptoJS.AES.decrypt(ciphertext, SECRET_COOKIE_KEY);
    return bytes.toString(CryptoJS.enc.Utf8);
  } catch (e) {
    // console.error("Error decrypting cookie:", e);
    return null; // Return null if decryption fails (e.g., corrupted or invalid cookie)
  }
};

// Define AKASA_API_KEY and AKASA_SENDER_ID outside the component
// or pass them down as props if coming from an external config.
// For production, these should be truly secure (e.g., via a backend proxy).
const AKASA_API_KEY = 'd57056c77bb1e88221f2f3893a8691af49e6a3855bd3d517628bfdd766c7fa48'; // <--- !!! REPLACE THIS !!!
const AKASA_SENDER_ID = 'Akasa.lk'; // <--- !!! REPLACE THIS !!!


async function sendSmsInBackground(smstoken) {
  if (!smstoken) {
    console.error('SMS Not Sent: Missing SMS token.');
    return;
  }

  const payload = {
    apiKey: AKASA_API_KEY,
    senderId: AKASA_SENDER_ID,
    smstoken: smstoken 
  };

  const smsApiEndpoint = 'https://stage.beachcabana.lk/hotelmanage/sendsms.php?param=sendregistersms'; // Relative to your proxy base URL

  try {
    await axios.post(smsApiEndpoint, payload, {
      headers: {
        'Content-Type': 'application/json', // Assuming JSON. Adjust if the API expects 'application/x-www-form-urlencoded'
      },
    });
    // SMS sent successfully. No UI update needed.
    // console.log('SMS sent successfully (background task).');
  } catch (err) {
    // Log SMS sending errors to console, but do not show to user
    console.error('Error sending SMS in background:', err);
    if (err.response) {
      console.error('SMS API Error Response (background):', err.response.data);
      console.error('SMS API Error Status (background):', err.response.status);
    } else if (err.request) {
      console.error('SMS Network Error (background): No response from SMS server.');
    } else {
      console.error('SMS Request setup error (background):', err.message);
    }
  }
  // No finally block to set loading or update UI states, as it's background.
}

export default function Register() {
  // Form State
  const [title, setTitle] = useState("Mr.");
  const [fullName, setFullName] = useState("");
  const [idType, setIdType] = useState("passport");
  const [idNumber, setIdNumber] = useState("");
  const [country, setCountry] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [checkInDate, setCheckInDate] = useState(new Date().toISOString().split("T")[0]);
  const [checkOutDate, setCheckOutDate] = useState("");
  const [roomType, setRoomType] = useState(1);
  const [numberOfGuest, setNumberOfGuest] = useState("2");
  const [message, setMessage] = useState("");
  const [agreedToTerms, setAgreedToTerms] = useState(true);
  const [spouseName, setSpouseName] = useState(""); // New state for spouse name
  const [showSpouseNameInput, setShowSpouseNameInput] = useState(false); // New state to control visibility

  // UI State
  const [registrationDisabled, setRegistrationDisabled] = useState(false);
  const [showTokenPopup, setShowTokenPopup] = useState(false);
  const [registrationToken, setregistrationToken] = useState("");
  const [currentOrderToken, setCurrentOrderToken] = useState("");
  const [showConfirmPopup, setShowConfirmPopup] = useState(false);
  const [isLoading, setIsLoading] = useState(false); // Main registration loading
  const [showInfoModal, setShowInfoModal] = useState(false);
  const [infoModalMessage, setInfoModalMessage] = useState("");
  const [showTermsModal, setShowTermsModal] = useState(false);

  // No separate SMS sending states needed, as per requirement to not show SMS response

  const navigate = useNavigate();

  const today = new Date().toISOString().split("T")[0];

  const getMinCheckOutDate = (checkIn) => {
    const date = new Date(checkIn);
    date.setDate(date.getDate() + 1);
    return date.toISOString().split("T")[0];
  };

  const minCheckOutDate = checkInDate ? getMinCheckOutDate(checkInDate) : today;

  useEffect(() => {
    const checkDeviceRegistration = () => {
      const encryptedDeviceRegistered = Cookies.get('deviceRegistered');
      const encryptedRegistrationExpiry = Cookies.get('registrationExpiry');
      const encryptedStoredToken = Cookies.get('registrationToken');

      if (encryptedDeviceRegistered && encryptedRegistrationExpiry && encryptedStoredToken) {
        const deviceRegistered = decrypt(encryptedDeviceRegistered);
        const registrationExpiry = decrypt(encryptedRegistrationExpiry);
        const storedToken = decrypt(encryptedStoredToken);

        if (deviceRegistered === 'true' && registrationExpiry && storedToken) {
          const expiryDate = new Date(registrationExpiry);
          if (new Date() < expiryDate) {
            setRegistrationDisabled(true);
            setCurrentOrderToken(storedToken);
            setInfoModalMessage(`Your Token is: ${storedToken}. Registration expires on: ${new Date(registrationExpiry).toLocaleString()}. Your token is based on the first 5 characters of your Passport or NIC.`);
            setShowInfoModal(true);
          } else {
            Cookies.remove('deviceRegistered');
            Cookies.remove('registrationExpiry');
            Cookies.remove('currentRegistrationId');
            Cookies.remove('registrationToken');
            setRegistrationDisabled(false);
            setCurrentOrderToken("");
          }
        } else {
          Cookies.remove('deviceRegistered');
          Cookies.remove('registrationExpiry');
          Cookies.remove('currentRegistrationId');
          Cookies.remove('registrationToken');
          setRegistrationDisabled(false);
          setCurrentOrderToken("");
        }
      }
    };
    checkDeviceRegistration();
  }, []);

  const fetchSpouseData = async (nic) => {
    try {
      const response = await axios.get(`https://nicvalidate.eamul.workers.dev/?nic=${nic}`);
      if (response.data && response.data.SpouseName) {
        setSpouseName(response.data.SpouseName);
        setShowSpouseNameInput(true); // Show the input if spouse name is found
      } else {
        setSpouseName("");
        setShowSpouseNameInput(false); // Hide if no spouse name
      }
    } catch (error) {
      console.error("Error fetching spouse data:", error);
      setSpouseName("");
      setShowSpouseNameInput(false);
    }
  };

  const handleIdNumberChange = (e) => {
    const value = e.target.value;
    setIdNumber(value);
    
    if (idType === "nic" && (value.length === 10 || value.length === 12)) {
      fetchSpouseData(value);
    } else {
      setSpouseName("");
      setShowSpouseNameInput(false);
    }
  };
  

  const handleInitialSubmit = (e) => {
    e.preventDefault();

    if (registrationDisabled) {
      setShowInfoModal(true);
      return;
    }

    if (!fullName || !idNumber || !country || !email || !phoneNumber || !checkInDate || !checkOutDate || !roomType) {
        setInfoModalMessage("Please fill in all required fields.");
        setShowInfoModal(true);
        return;
    }

    if (new Date(checkOutDate) <= new Date(checkInDate)) {
        setInfoModalMessage("Check-out date must be after check-in date.");
        setShowInfoModal(true);
        return;
    }

    const numericIdPartForValidation = idNumber.replace(/\D/g, '');
    if (numericIdPartForValidation.length < 1) {
        setInfoModalMessage("ID Number must contain at least one digit to generate a menu order token.");
        setShowInfoModal(true);
        return;
    }

    if (!agreedToTerms) {
      setInfoModalMessage("You must agree to the hotel's terms and conditions to register.");
      setShowInfoModal(true);
      return;
    }

    setShowConfirmPopup(true);
  };

  const confirmAndSubmit = async () => {
    setShowConfirmPopup(false);
    setIsLoading(true); // Start main registration loading

    const checkOutDateTime = new Date(`${checkOutDate}T11:00:00`);
    const numericIdPart = idNumber;

    let generatedToken;
    if (numericIdPart.length >= 5) {
      generatedToken = numericIdPart.substring(0, 5);
    } else if (numericIdPart.length > 0) {
      generatedToken = numericIdPart;
    } else {
      setInfoModalMessage("ID Number must contain at least one digit to generate a menu order token.");
      setShowInfoModal(true);
      setIsLoading(false);
      return;
    }

    const registrationData = {
      title,
      fullName,
      idType,
      idNumber,
      country,
      email,
      phoneNumber,
      checkInDate,
      checkOutDate,
      roomType,
      numberOfGuest,
      message,
      submittedAt: new Date().toISOString(),
      registrationExpiresAt: checkOutDateTime.toISOString(),
      token: generatedToken,
      spouseName: spouseName, // Include spouse name in registration data
    };

    try {
      // Base URL for the API (uses your proxy)
      const externalApiUrl = `https://stage.beachcabana.lk/hotelmanage/api.php?param=register`; // Relative to your proxy

      const apiResponse = await axios.post(externalApiUrl, registrationData, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Basic YWRtaW46cGFzc3dvcmQ=' // Use the Basic Auth header here
        }
      });

      if (apiResponse.data.code === 200) {
        const accessToken = apiResponse.data.data?.reservation_id;
        const smsToken = apiResponse.data.data?.smstoken; // Get SMS token from response

        if (smsToken) {
            sendSmsInBackground(smsToken);
        } else {
            console.warn("SMS not sent: Missing SMS token or phone number from registration response.");
        }
        // --- END SMS CALL ---

        // Set cookies only after successful external API registration
        Cookies.set('deviceRegistered', encrypt('true'), { expires: checkOutDateTime });
        Cookies.set('registrationExpiry', encrypt(checkOutDateTime.toISOString()), { expires: checkOutDateTime });
        Cookies.set('currentRegistrationId', encrypt(accessToken), { expires: checkOutDateTime });
        Cookies.set('registrationToken', encrypt(String(generatedToken)), { expires: checkOutDateTime });

        setRegistrationDisabled(true);
        setregistrationToken(String(generatedToken));
        setCurrentOrderToken(String(generatedToken));

        setShowTokenPopup(true);

        // Clear form
        setTitle("Mr.");
        setFullName("");
        setIdType("passport");
        setIdNumber("");
        setCountry("");
        setEmail("");
        setPhoneNumber("");
        setCheckInDate(new Date().toISOString().split("T")[0]);
        setCheckOutDate("");
        setRoomType(1);
        setNumberOfGuest("2");
        setMessage("");
        setAgreedToTerms(true);
        setSpouseName(""); // Clear spouse name
        setShowSpouseNameInput(false); // Hide spouse name input

      } else {
        setInfoModalMessage(`${apiResponse.data.message || 'Unknown error during registration'}`);
        setShowInfoModal(true);
      }

    } catch (err) {
      setInfoModalMessage(`Registration failed: ${err.message}. Check console for details.`);
      setShowInfoModal(true);
      console.error("Main Registration Error:", err);
    } finally {
      setIsLoading(false); // End main registration loading
    }
  };

  // const closeTokenPopup = () => {
  //   setShowTokenPopup(false);
  // };

  const cancelConfirm = () => {
    setShowConfirmPopup(false);
  };

  const handleGoBack = () => {
    setShowInfoModal(false);
    navigate('/');
  };

  return (
    <Layout pageTitle="Registration">
      <form onSubmit={handleInitialSubmit} className={`space-y-4 ${registrationDisabled ? 'opacity-50 pointer-events-none' : ''}`}>
        {/* ... (Your existing form fields, they are unchanged) ... */}
        {/* Title */}
        <div>
          <label htmlFor="title" className="block mb-2 text-sm font-medium text-gray-900">Title<span className="text-red-600 ml-1">*</span></label>
          <select
            id="title"
            className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            required
          >
            <option>Mr.</option>
            <option>Mrs</option>
            <option>Miss.</option>
            <option>Ms.</option>
          </select>
        </div>

        {/* Full Name */}
        <div>
          <label className="block mb-2 text-sm font-medium text-gray-900">Full Name<span className="text-red-600 ml-1">*</span></label>
          <input
            type="text"
            value={fullName}
            onChange={(e) => setFullName(e.target.value)}
            required
            className="bg-white border border-gray-300 text-sm rounded-lg block w-full p-2.5"
          />
        </div>

        {/* ID Type */}
        <div>
          <label className="block mb-2 text-sm font-medium text-gray-900">ID Type<span className="text-red-600 ml-1">*</span></label>
          <div className="flex gap-4">
            {["passport", "nic"].map((type) => (
              <label
                key={type}
                className={`inline-flex items-center w-1/2 p-4 border rounded-md cursor-pointer ${
                  idType === type ? "border border-blue-600 ring-blue-600 text-sm rounded-lg " : "border-gray-300"
                }`}
              >
                <input
                  type="radio"
                  value={type}
                  checked={idType === type}
                  onChange={() => {
                    setIdType(type);
                    setIdNumber(""); // Clear ID number when type changes
                    setSpouseName(""); // Clear spouse name when type changes
                    setShowSpouseNameInput(false); // Hide spouse name input when type changes
                  }}
                  className="sr-only"
                />
                <span className="w-4 h-4 rounded-full border border-gray-300 bg-white flex items-center justify-center mr-2">
                  {idType === type && <span className="w-2 h-2 rounded-full bg-blue-600"></span>}
                </span>
                <span className="text-sm font-medium capitalize">{type === "nic" ? "NIC Number" : "Passport"}</span>
              </label>
            ))}
          </div>
        </div>

        {/* Conditional ID Input */}
        <div>
          <label className="block mb-2 text-sm font-medium text-gray-900">
            {idType === "passport" ? "Passport Number" : "NIC Number"}<span className="text-red-600 ml-1">*</span>
          </label>
          <input
            type="text"
            value={idNumber}
            onChange={handleIdNumberChange} // Use the new handler
            required
            className="bg-white border border-gray-300 text-sm rounded-lg block w-full p-2.5"
            maxLength={idType === "nic" ? 12 : undefined} // Allow max 12 chars for NIC (including V/X)
            minLength={idType === "nic" ? 9 : 5} // Min 9 for NIC, 5 for passport
          />
        </div>

        {/* Spouse Name Input (conditionally rendered) */}
        {showSpouseNameInput && (
          <div>
            <label className="block mb-2 text-sm font-medium text-gray-900">Spouse Name</label>
            <input
              type="text"
              value={spouseName}
              readOnly // Make it read-only as it's fetched from API
              className="bg-green-50 border border-green-300 text-green-900 text-sm rounded-lg block w-full p-2.5"
            />
          </div>
        )}

        {/* Country (No 3-char limit) */}
        <div>
          <label className="block mb-2 text-sm font-medium text-gray-900">Country<span className="text-red-600 ml-1">*</span></label>
          <input
            type="text"
            value={country}
            onChange={(e) => setCountry(e.target.value)}
            required
            className="bg-white border border-gray-300 text-sm rounded-lg block w-full p-2.5"
            minLength={3}
            maxLength={20}
          />
        </div>

        {/* Email */}
        <div>
          <label className="block mb-2 text-sm font-medium text-gray-900">Email Address<span className="text-red-600 ml-1">*</span></label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="bg-white border border-gray-300 text-sm rounded-lg block w-full p-2.5"
            minLength={6}
            maxLength={25}
          />
        </div>

        {/* Phone */}
        <div>
          <label className="block mb-2 text-sm font-medium text-gray-900">Phone Number<span className="text-red-600 ml-1">*</span></label>
          <input
            type="tel"
            value={phoneNumber}
            onChange={(e) => setPhoneNumber(e.target.value)}
            required
            className="bg-white border border-gray-300 text-sm rounded-lg block w-full p-2.5"
            minLength={10}
            maxLength={15}
          />
        </div>

        {/* Check-in / Check-out */}
        <div className="grid sm:grid-cols-2 gap-4">
          <div>
            <label className="block mb-2 text-sm font-medium text-gray-900">Check-in Date</label>
            <input
              type="date"
              value={checkInDate}
              onChange={(e) => {
                setCheckInDate(e.target.value);
                if (new Date(checkOutDate) <= new Date(e.target.value)) {
                  setCheckOutDate("");
                }
              }}
              min={today}
              required
              disabled
              className="bg-white border border-gray-300 text-sm rounded-lg block w-full p-2.5"
            />
          </div>


          <div>
            <label className="block mb-2 text-sm font-medium text-gray-900">Check-out Date<span className="text-red-600 ml-1">*</span></label>
            <input
              type="date"
              value={checkOutDate}
              onChange={(e) => setCheckOutDate(e.target.value)}
              min={minCheckOutDate}
              required
              className="bg-white border border-gray-300 text-sm rounded-lg block w-full p-2.5"
            />
          </div>
        </div>

        {/* Room Type */}
        <div>
          <label className="block mb-2 text-sm font-medium text-gray-900">Room Type<span className="text-red-600 ml-1">*</span></label>
          <select
            className="bg-white border border-gray-300 text-sm rounded-lg block w-full p-2.5"
            value={roomType}
            onChange={(e) => setRoomType(e.target.value)}
            required
          >
            <option value="">Select Room Type</option>
            <option value="1">Deluxe Double Room</option>
          </select>
        </div>

        {/* Number of Guests */}
        <div>
          <label className="block mb-2 text-sm font-medium text-gray-900">Number of Guests<span className="text-red-600 ml-1">*</span></label>
          <div className="flex gap-4">
            {[
              { label: "Solo (1)", value: 1 },
              { label: "Couple (2)", value: 2 },
              { label: "Family (3)", value: 3 },
            ].map(({ label, value }) => (
              <label
                key={value}
                className={`bg-white inline-flex items-center w-full sm:w-1/3 p-3 border rounded-md cursor-pointer ${
                  numberOfGuest === value ? "border border-blue-600 ring-blue-600 text-sm rounded-lg bg-white" : "border-gray-300"
                }`}
              >
                <input
                  type="radio"
                  value={value}
                  checked={numberOfGuest === value}
                  onChange={() => setNumberOfGuest(value)}
                  className="sr-only"
                />
                <span className="w-4 h-4 rounded-full border border-gray-300 bg-white flex items-center justify-center mr-2">
                  {numberOfGuest === value && <span className="w-2 h-2 rounded-full bg-blue-600"></span>}
                </span>
                <span className="text-sm font-medium">{label}</span>
              </label>
            ))}
          </div>
        </div>


        <div>
          <label htmlFor="message" className="block mb-2 text-sm font-medium text-gray-900">Special Request</label>
          <textarea
            id="message"
            rows="4"
            className="block p-2.5 w-full text-sm text-gray-900 bg-white rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-500"
            placeholder="Write your thoughts here..."
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          ></textarea>
        </div>


           {/* Terms and Conditions Checkbox */}
        <div className="flex items-center">
          <input
            id="terms-checkbox"
            type="checkbox"
            checked={agreedToTerms}
            onChange={(e) => setAgreedToTerms(e.target.checked)}
            className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500"
            required
          />
          <label htmlFor="terms-checkbox" className="ml-2 text-sm font-medium text-gray-900">
            I agree to the hotel's{" "}
            <span
              className="text-blue-600 hover:underline cursor-pointer"
              onClick={() => setShowTermsModal(true)}
            >
              terms and conditions
            </span>
          </label>
        </div>

        {/* Submit */}
        <div className="text-center pt-4">
          <button
            type="submit"
            className={`w-full px-6 py-2 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 ${registrationDisabled || isLoading ? 'opacity-50 cursor-not-allowed' : ''}`}
            disabled={registrationDisabled || isLoading}
          >
            {isLoading ? "Registering..." : "Register"}
          </button>
        </div>
      </form>

      {/* Confirmation Popup */}
      {showConfirmPopup && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white w-full max-w-sm mx-auto rounded-lg shadow-lg p-6 text-center">
            <h3 className="text-xl font-bold mb-4 text-gray-800">Confirm Registration</h3>
            <p className="text-gray-700 mb-6">
              Are you sure you want to register with these details?
            </p>
            <div className="text-center gap-4">

              <button
                onClick={confirmAndSubmit}
                className={`px-6 py-2 w-full bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 ${isLoading ? 'opacity-50 cursor-not-allowed' : ''}`}
                disabled={isLoading}
              >
                Confirm
              </button>

              <button
                onClick={cancelConfirm}
                className="px-6 py-2 w-full bg-white text-gray-800 font-semibold rounded-lg hover:text-gray-500 mt-3"
              >
                Cancel
              </button>

            </div>

          </div>
        </div>
      )}

      {/* Menu Order Token Popup */}
      {showTokenPopup && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white w-full max-w-sm mx-auto rounded-lg shadow-lg p-6 text-center">
            <h3 className="text-2xl font-bold mb-4 text-green-600">Registration Successful!</h3>
            <p className="text-gray-700 mb-4">
              Your Token is:
            </p>
            <p className="text-4xl text-blue-700 mb-6 tracking-wide">
            {registrationToken}
            </p>
            <p className="text text-gray-600 mb-6 italic">
              Use this token to order from another device. It's based on the first 5 characters of your NIC/Passport.
            </p>
            {/* Removed SMS loading/error/response messages here */}
            <button
              onClick={handleGoBack}
              className="w-full px-6 py-2 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700"
            >
              Go back
            </button>
          </div>
        </div>
      )}

      {/* General Info/Error Modal (now also used for "device already registered") */}
      {showInfoModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
          <div className="bg-white w-full max-w-sm mx-auto rounded-lg shadow-lg p-6 text-center">
            {registrationDisabled ? (
              <>
                <h3 className="text-xl mb-4 text-green-600">You're Registered!</h3>
                <p className="text-gray-700 mb-4">Your Token</p>
                <p className="text-4xl text-blue-700 mb-6 tracking-wide">
                  {currentOrderToken}
                </p>

                <p className="text text-gray-600 mb-6 italic">
                Use this token to order from another device. It's based on the first 5 characters of your NIC/Passport.
                </p>
                <button
                  onClick={handleGoBack}
                  className="w-full px-6 py-2 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700"
                >
                  Go Back
                </button>
              </>
            ) : (
              <>
                <h3 className="text-xl font-bold mb-4 text-gray-800">Information</h3>
                <p className="text-gray-700 mb-6">{infoModalMessage}</p>
                <button
                  onClick={() => setShowInfoModal(false)}
                  className="px-6 py-2 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700"
                >
                  OK
                </button>
              </>
            )}
          </div>
        </div>
      )}

      {/* Terms and Conditions Modal */}
      {showTermsModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white w-full max-w-lg mx-auto rounded-lg shadow-lg p-6">
            <h3 className="text-xl font-bold mb-4 text-gray-800">Terms and Conditions</h3>
            <div className="max-h-96 overflow-y-auto text-gray-700 text-sm mb-6 p-2">
              <p className="mb-2">
                Welcome to Wood Chalets Ella. By proceeding with this registration, you agree to abide by the following terms and conditions:
              </p>
              <ul className="list-disc list-inside mb-4">
                <li>All guests must enter their passport number correctly if they are foreign tourists, or their National Identity Card number correctly if they are domestic tourists.</li>
                <li>Check-in time is 12:00 PM, and check-out time is 11:00 AM.</li>
                <li>Smoking is strictly prohibited inside the room. Please use the balcony if you wish to smoke.</li>
                <li>Guests will be held responsible for any serious damage caused to hotel property during their stay.</li>
                <li>Pets are not allowed on the premises.</li>
                <li>The hotel reserves the right to refuse service to anyone at its sole discretion.</li>
                <li>By providing your email address and phone number, you consent to receive communications related to your stay.</li>
                <li>If you experience any damage or inconvenience during your stay, it will be addressed based on the information you have provided. If the information is incorrect, the hotel will not be responsible for any resulting issues.</li>
              </ul>
              <p>
                Please ensure you have read and understood these terms before completing your registration.
              </p>
            </div>
            <button
              onClick={() => setShowTermsModal(false)}
              className="w-full px-6 py-2 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700"
            >
              Close
            </button>
          </div>
        </div>
      )}
    </Layout>
  );
}